var SCM = SCM || {};

SCM.LoginBox = (function($, SCM) {

    var _isLoginBoxLoaded = false;
    var $dropdownContents = $('.js-login-box-placeholder');
    var decodedUrl = '';
    const _modalActivityPropertyName = 'ModalActivityId';
    const modalTagToKeepState = '.js-content-alert-modal';

    return {
        init: init,
        getZEncodedRedirectUrl: getZEncodedRedirectUrl,
        updateHrefPlaceholder: updateHrefPlaceholder
    }

    function init() {
        // Update content for (non-drop-down) sign-in boxes that are embedded in the page.
        // (e.g., the sign box on the /sign-in page 
        //        or the box at the bottom of content pages when the user is not authorized)
        // NOTE: we don't call functions that are triggered by events anyway.
        getRedirectBaseUrl();
        addReturnUrlToSocietyLinks();
        restoreModalState();

        // register handlers
        $(document).on('click', documentClick);
        $(document).on('keyup', documentKeyUp);
    }

    function getRedirectBaseUrl() {
        if (decodedUrl === '' && $('#RedirectSiteUrl').length) {
            var redirectSiteUrl = $('#RedirectSiteUrl').val();
            decodedUrl = SCM.ZEncoderV1.Decode(redirectSiteUrl);
        }
    }

    function updateSignInLink($el, linkUrl) {
        saveModalStateBeforeRedirecting($el);
        
        let zEncodedRedirectUrl = getZEncodedRedirectUrl($el);
        
        if ($el.hasClass('js-shibboleth-login')) {
            // we need to use '<something>redirecturl' because the LoginHandler expects a non-empty state value
            // when extracting the redirect url.
            // Could be coming from proxy, so using encoded live/preview site url
            var url = encodeURIComponent(decodedUrl +
                '/HTTPHandlers/Sigma/LoginHandler.ashx?state=xredirecturl%3D' +
                zEncodedRedirectUrl);
            updateHrefPlaceholder($el, url, linkUrl);
        } else {
            updateHrefPlaceholder($el, zEncodedRedirectUrl, linkUrl);
            updateRedirectUri($el, 'Sigma/LoginHandler.ashx');
        }
    }

    function getZEncodedRedirectUrl($el = null) {
        var redirectUrl = getRedirectPageUrl(true, $el);
        var returnUrlParam = SCM.JSUtility.getSearchParamByName('returnUrl');

        if (isSignInPageWithReturnUrl(redirectUrl, returnUrlParam)) {
            redirectUrl = getZEncodedReturnUrl(returnUrlParam);
        }

        return redirectUrl;
    }

    function isSignInPageWithReturnUrl(redirectUrl, returnUrlParam) {
        return redirectUrl.includes('signzyin') && redirectUrl.includes('returnUrl') && returnUrlParam !== undefined;
    }

    function getZEncodedReturnUrl(returnUrlParam) {
        if (returnUrlParam.includes('httpszazjzj')) {
            return returnUrlParam;
        }

        return SCM.ZEncoderV1.Encode(returnUrlParam);
    }
    
    function updateRedirectUri($el, handler) {
        var href = $el.attr('href');
        var params = href.split('&');

        $.each(params,
            function(idx, val) {
                // only change the redirect uri parameter of the href
                if (val.startsWith('redirect_uri')) {
                    var queryString = val.split('?');
                    params[idx] = 'redirect_uri=' + decodedUrl + '/HTTPHandlers/' + handler;
                    if (queryString.length > 1) {
                        params[idx] += '?' + queryString[1];
                    }
                }
            });
        $el.attr('href', params.join('&'));
    }

    function updateLinkAndGo($el) {
        var linkType = $el.data('linktype');
        SCM.Ajax.get('/Accounts/GetLinkUrl', { linkType: linkType })
            .expectJson()
            .then(function(data) {
                switch (linkType) {
                case 'sign-out':
                    updateSignOutLink($el, data);
                    window.location.href = $el.attr('href');
                    break;
                case 'user-pass':
                case 'library-card':
                    updateSignInLink($el, data);
                    window.location.href = $el.attr('href');
                    break;
                }
            });
    }

    function updateSignOutLink($el, linkUrl) {
        var currentPage = getRedirectPageUrl({ zEncode: true });
        updateHrefPlaceholder($el, currentPage, linkUrl);
        updateRedirectUri($el, 'SAMS/LogoutHandler.ashx');
    }

    function saveModalStateBeforeRedirecting($el) {
        var $modal = $el.closest(modalTagToKeepState);
        if ($modal.length) {
            sessionStorage.setItem(_modalActivityPropertyName, $modal.attr('id'));
        }
    }

    function restoreModalState() {
        var modalId = sessionStorage.getItem(_modalActivityPropertyName);
        if (modalId) {
            var $modal = $('#' + modalId);
            if ($modal.length) {
                App.MyEmailAlerts.getActivityAlertModal();
                $modal.foundation('reveal', 'open');
                sessionStorage.removeItem(_modalActivityPropertyName);
            }
        }
    }
    
    function updateRegisterLink($el) {
        saveModalStateBeforeRedirecting($el);

        var currentPage = getRedirectPageUrl({ zEncode: true });
        // z-encoded form
        if (currentPage.includes('signzyin') && currentPage.includes('returnUrl')) {
            return;
        }
        var href = $el.attr('href');
        href = href.substring(0, href.indexOf('returnUrl='));
        href += ('returnUrl=' + currentPage);
        $el.attr('href', href);
    }

    function updateHrefPlaceholder($el, currentPage, linkUrl) {
       
        // if login=true is only param and there's a hash, you'll end up with ?#<hashval> which is invalid
        if (currentPage.indexOf('?%23') !== -1) {
            currentPage = currentPage.replace('?%23', '%23');
        }
        // sanitize what might be a JSON string value for Sigma login calls!
        while (linkUrl.indexOf('"') > -1) {
            linkUrl = linkUrl.replace('"', '%22');
        }
        // replace the actual placeholders (there may be more than one)
        while (linkUrl.indexOf('RedirectUrlPlaceholder') > -1) {
            linkUrl = linkUrl.replace('RedirectUrlPlaceholder', currentPage);
        }
        $el.attr('href', linkUrl);
    }

    function removeUnneededParams(page, paramToRemove) {
        return page.replace('&'+paramToRemove, '').replace('?'+paramToRemove, '?').replace('?&', '?');
    }

    /** NARN-18265: Drop any `login` query parameter and return the current page location
     *  in Z encoded form (e.g., 'hi world' -> 'hiziworld').                              */
    /** NARN-22833: Modify the function to conditionally return a different URL based on an optional element param. */
    function getRedirectPageUrl(zEncode=false, $el=null) {
        let redirectPage = window.location.href;
        
        redirectPage = removeUnneededParams(redirectPage, 'login=true');
        redirectPage = removeUnneededParams(redirectPage, 'login=false');
        redirectPage = removeUnneededParams(redirectPage, 'error=login_retry');
        if (redirectPage.includes('token=')) {
            redirectPage = redirectPage.substring(0, redirectPage.indexOf('token=')-1);
        }
        if (redirectPage.endsWith('?')) {
            redirectPage = redirectPage.slice(0, -1); 
        }
        return zEncode ? SCM.ZEncoderV1.Encode(redirectPage) : redirectPage;
    }

    function hideDropDown() {
        $('.js-login-box-placeholder').css('z-index', 'auto');
        $('#InfoColumn').css('z-index', 6000);
        $dropdownContents.addClass('hide');
    }

    function documentKeyUp(e) {
        if (e.key === 'Escape') {
            hideDropDown();
        }
    }

    function hidePageDropdowns() {
        $('.site-menu-lvl-0').find('.site-menu:visible').slideToggle('fast');
        $('.f-dropdown:visible').slideToggle('fast');
    }

    function documentClick(e) {
        var $target = $(e.target).closest('a');
        // need to update urls to include hashes, params, etc.
        if (_isElementTargetedByEvent(e, $('.js-account-button'))) {
            $dropdownContents.toggleClass('hide');
            hidePageDropdowns();
            if (!_isLoginBoxLoaded) {
                loadLoginBox($dropdownContents, $('.js-account-button'));
            }
            $('.js-login-box-placeholder').css('z-index', 6000);
            $('#InfoColumn').css('z-index', 'auto');
        }
        else if (_isElementTargetedByEvent(e, $('.js-shibboleth-login'))) {
            var linkUrl = $target.attr('href');
            updateSignInLink($target, linkUrl);
            window.location.href = $target.attr('href');
        }
        else if (_isElementTargetedByEvent(e, $('.js-sign-in-link')) ||
                 _isElementTargetedByEvent(e, $('.js-sign-out-link'))) {
            updateLinkAndGo($target);
        }
        else if (_isElementTargetedByEvent(e, $('.js-register-link'))) {
            updateRegisterLink($target);
            window.location.href = $target.attr('href');
        }
        else if (_isElementTargetedByEvent(e, $('.js-society-sign-in'))) {
            window.location.href = $('.js-society-sign-in').attr('href');
        }
        else if (_isElementTargetedByEvent(e, $('.js-externalLogin-link'))) {
            e.preventDefault();
            updateExternalLoginLink();
            window.location.href = $('.js-externalLogin-link').attr('href');
        }
        else if (_isElementTargetedByEvent(e, $('.js-login-help'))) {
            var $lastActiveElement = $('.js-login-help');
            showAccessModal($lastActiveElement);
        }
        else if (_isTargetClickNotInElement(e, $dropdownContents)) {
            hideDropDown();
        }
    }

    function loadLoginBox($targetLocation, $elem) {
        var baseUrl = App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '';             
        var turnAwayParams = $elem.attr('data-turnawayparams');
        var queryParams = turnAwayParams.length ? '?turnAwayParams=' + turnAwayParams : '';
        queryParams += (queryParams.length ? '&' : '?') + 'SignInReturnUrl=' + encodeURIComponent(window.location.href);
        $.get(baseUrl + '/Accounts/LoginBox/LoginBox' + queryParams).done(function(html) {
            $targetLocation.html(html);
            _isLoginBoxLoaded = true;
            addReturnUrlToSocietyLinks();
            getRedirectBaseUrl();
            App.OUPSeamlessAccess.updateButton();
        });
    }
    
    function addReturnUrlToSocietyLinks() {

        var returnUrl = getSocietyReturnUrl(true);
        returnUrl = encodeURIComponent(returnUrl);
        var placeholderHf = $('#hfPlaceholderReturnUrlValue');
        var placeholder = placeholderHf.length ? placeholderHf.val() : null;

        $('.society-links-logo, .society-links-url').each(function () {
            if (placeholder && placeholder.length)
            {
                var $this = $(this);
                $this.attr('href', $this.attr('href').replace(placeholder, returnUrl));
            }
        });
    }

    function updateExternalLoginLink() {
        $('.js-externalLogin-link').each(function () {
            var $this = $(this);
            var href = $this.attr('href');
            //change hostname using decodedUrl (mainly for proxy)
            var url = new URL(href);
            url.hostname = decodedUrl.replace('https://', '');
            url += getQueryStringSeparator(href) + '&requestHost=' + window.location.host;
            $this.attr('href', url);
        });
    }

    function getQueryStringSeparator(url) {
        var urlObj = new URL(url);
        return urlObj.search.length ? '&' : '?';
    }

    function getSocietyReturnUrl(addSigmaHost) {
        var returnUrl = getRedirectPageUrl();
        var host = window.location.host;
        var encodedHost = encodeURIComponent(host);
        if (addSigmaHost) {
            returnUrl += getQueryStringSeparator(returnUrl) + 'sigmaHost=' + encodedHost;
        }
        returnUrl += window.location.hash;
        return returnUrl;
    }

    function showAccessModal($lastActiveElement) {
        var $divHelp = $('#divAccessHelp');
        var $closeBtn = $divHelp.find('.js-access-help-close');
        $divHelp.off('opened.fndtn.reveal');
        $divHelp.on('opened.fndtn.reveal', function () {
            SCM.trapFocus.publicTrapFocus($divHelp, $closeBtn, $lastActiveElement);
            $closeBtn.off('click');
            $closeBtn.on('click', function (e) {
                e.stopPropagation();
                $divHelp.foundation('reveal', 'close');
                $lastActiveElement.focus();
             });
            $divHelp.focus();
        });
        $divHelp.foundation('reveal', 'open');
    }

    function _isTargetClickNotInElement(e, $element) {
        return !$element.is(e.target) && !$element.has(e.target).length;
    }

    function _isElementTargetedByEvent(e, $element) {
        return $element.is(e.target) || $element.has(e.target).length;
    }
})(jQuery, SCM);
